// @ts-nocheck
import { useState, useLayoutEffect, useEffect } from "react";
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { UAParser } from "ua-parser-js";

function getNowInJST() {
    const now = new Date();
    const jstString = now.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
    return new Date(jstString);
}

function chunkArray(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}

function isWithinDisplayTime() {
    const now = getNowInJST();
    const hour = now.getHours();
    return hour >= 8 && hour < 20;
}

function MyCalendar() {
    const [cookies] = useCookies(['sessionToken']);
    const [myEmail, setMyEmail] = useState("");
    const [browserInfo, setBrowserInfo] = useState('');
    const [gasData, setGasData] = useState(null);
    const [nowText, setNowText] = useState("");
    const [shouldShow, setShouldShow] = useState(true);
    const [defaultText, setdefaultText] = useState("@麻布台");
    const [isLongScrollKaigisitsu, setIsLongScrollKaigisitsu] = useState(false);
    const [isLongScrollTelebooth, setIsLongScrollTelebooth] = useState(false);

    useEffect(() => {
        const uaParserResult = UAParser(window.navigator.userAgent);
        if (uaParserResult.browser['name'] !== 'Chrome') {
            setBrowserInfo('notChrome');
        }
    }, []);

    useLayoutEffect(() => {
        if (cookies.sessionToken) {
            const decoded = jwt_decode(cookies.sessionToken);
            let email = decoded.data.EMAIL;
            email = email.replace("@zenken.co.jp", "");
            setMyEmail(email);
        }
        if (cookies.buildingSlug !== "inBuilding" && cookies.sectionCodeId1 !== "313") {
            setShouldShow(true);
        }
        if (cookies.sectionCodeId1 === "313") {
            setShouldShow(true);
            setdefaultText("@沖縄オフィス");
        }
    }, []);

    useEffect(() => {
        fetch("/dev/proxy.php?date=2025-04-22")
            .then(async (res) => {
                const text = await res.text();
                try {
                    const json = JSON.parse(text);
                    const filteredRooms = json.rooms?.filter(room => {
                        if (cookies.sectionCodeId1 === '313') {
                            return room.buildingId === '沖縄オフィス';
                        } else {
                            return room.buildingId === '麻布台';
                        }
                    });
                    console.log("filteredRooms", filteredRooms);
                    setGasData({ ...json, rooms: filteredRooms });
                } catch (err) { }
            })
            .catch(err => { });

        const now = getNowInJST();
        const month = now.getMonth() + 1;
        const day = now.getDate();
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        setNowText(`${month}/${day} ${hour}:${minute}`);
    }, []);

    const renderTable = (title, filteredMap, additionalClass = "", isLong = false) => {
        const jstNow = getNowInJST();
        const timeSlots = Object.keys(filteredMap);
        const isTelebooth = title.includes("テレブース");

        return (
            <div className={`table-main ${additionalClass}`}>
                <div className="table-title">
                    {title}
                    {isTelebooth && (
                        <small style={{ display: 'flex', fontWeight: 'normal' }}>
                            ※ブース【16】は2名、【17】は４名、それ以外は１名ブースとなります。
                        </small>
                    )}
                </div>
                <div className={`table-scroll${isLong ? " long" : ""}`}>
                    <table className="table table-bordered mb-0">
                        <tbody>
                            {timeSlots.map((time) => {
                                const rows = chunkArray(filteredMap[time], 100);
                                const rowClass = `timeslot-${time.replace(":", "")}`;
                                return rows.map((row, rowIndex) => (
                                    <tr
                                        key={`${title}-${time}-row-${rowIndex}`}
                                        className={`${rowClass} ${rowIndex === 0 ? 'first-of-slot' : ''}`}
                                    >
                                        {rowIndex === 0 ? <th rowSpan={rows.length}>{time}</th> : null}
                                        {row.map((entry, i) => {
                                            const [startH, startM] = entry.start.split(":");
                                            const [endH, endM] = entry.end.split(":");

                                            const startDate = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate(), Number(startH), Number(startM));
                                            const endDate = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate(), Number(endH), Number(endM));

                                            const toGoogleDateTime = (date) => {
                                                const yyyy = date.getFullYear();
                                                const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                const dd = String(date.getDate()).padStart(2, '0');
                                                const hh = String(date.getHours()).padStart(2, '0');
                                                const min = String(date.getMinutes()).padStart(2, '0');
                                                return `${yyyy}${mm}${dd}T${hh}${min}00`;
                                            };

                                            const simplifiedName = entry.name
                                                .replace(/(テレブース|会議室)/g, '')
                                                .replace(/^\s+|\s+$/g, '');

                                            const label = isTelebooth
                                                ? `${entry.start} - ${entry.end} | ${simplifiedName}`
                                                : `${entry.start} - ${entry.end} | ${simplifiedName} (${entry.capacity})`;

                                            let linkClass = 'table-link';
                                            if (isTelebooth) {
                                                linkClass += ' tel';
                                                if (simplifiedName.length <= 2) {
                                                    linkClass += ' many';
                                                }
                                            }

                                            const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${toGoogleDateTime(startDate)}/${toGoogleDateTime(endDate)}`;

                                            return (
                                                <td key={i}>
                                                    <a className={linkClass} href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                                        {label}
                                                    </a>
                                                </td>
                                            );
                                        })}
                                        {/* {Array.from({ length: 3 - row.length }).map((_, i) => (
                                            <td key={`empty-${i}`}></td>
                                        ))} */}
                                    </tr>
                                ));
                            })}
                        </tbody>
                    </table>
                </div>
                {isTelebooth ? (
                    cookies.sectionCodeId1 !== "313" && (
                        <div className="table-more" style={{ textAlign: "center" }}>
                            <button
                                className="table-more-button"
                                onClick={() => setIsLongScrollTelebooth(prev => !prev)}
                            >
                                {/* {isLongScrollTelebooth ? '閉じる' : 'もっと見る（テレブース）'} */}
                                <div class="icon-area"></div>
                            </button>
                        </div>
                    )
                ) : (
                    <div className="table-more" style={{ textAlign: "center" }}>
                        <button
                            className="table-more-button"
                            onClick={() => setIsLongScrollKaigisitsu(prev => !prev)}
                        >
                            {/* {isLongScrollKaigisitsu ? '閉じる' : 'もっと見る（会議室）'} */}
                            <div class="icon-area"></div>
                        </button>
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            {shouldShow && isWithinDisplayTime() && (
                <div className="kaigisitu_wrap">
                    <div className="icon-title-area">
                        <h2 className="icon-title type-kaigisitu mb-0">本日の空き会議室</h2>
                        <div className="icon-title-sub">{defaultText}（8:00-20:00 | {nowText}時点）</div>
                    </div>
                    <small>下記の時間からGカレが開きますが、「会議室」はご自身で紐づけをお願いします。</small>
                    <div>
                        {gasData && gasData.rooms ? (() => {
                            const jstNow = getNowInJST();
                            const timeSlots = [];
                            for (let h = 8; h < 20; h++) {
                                timeSlots.push(`${String(h).padStart(2, '0')}:00`);
                                timeSlots.push(`${String(h).padStart(2, '0')}:30`);
                            }

                            const kaigisitsuMap = {};
                            const teleboothMap = {};
                            timeSlots.forEach(t => {
                                kaigisitsuMap[t] = [];
                                teleboothMap[t] = [];
                            });

                            gasData.rooms.forEach(room => {
                                room.freeSlots.forEach(slot => {
                                    const [startHour] = slot.start.split(":");
                                    const timeKey = `${startHour.padStart(2, '0')}:00`;

                                    const entry = {
                                        name: room.resourceName,
                                        capacity: room.capacity || '',
                                        start: slot.start,
                                        end: slot.end
                                    };

                                    if (room.resourceName.includes("テレブース")) {
                                        if (teleboothMap[timeKey]) {
                                            teleboothMap[timeKey].push(entry);
                                        }
                                    } else if (room.resourceName.includes("会議室")) {
                                        if (kaigisitsuMap[timeKey]) {
                                            kaigisitsuMap[timeKey].push(entry);
                                        }
                                    }
                                });
                            });

                            return (
                                <div className="table-wrap">
                                    {renderTable(
                                        "会議室",
                                        kaigisitsuMap,
                                        cookies.sectionCodeId1 !== "313" ? "" : "okinawa",
                                        isLongScrollKaigisitsu
                                    )}
                                    {cookies.sectionCodeId1 !== "313" &&
                                        renderTable("テレブース", teleboothMap, "", isLongScrollTelebooth)}

                                </div>
                            );
                        })() : <p>読み込み中...</p>}
                    </div>
                </div>
            )}
        </>
    );
}

export default MyCalendar;
